<script>
    import {_, locale, number} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {

        itemDetails.title = $_('PrisonCampLiberationPassPackItemTitle', {
            values: {AMOUNT: $number(gameItem.amount)},
        });

        itemDetails.description = $_("PrisonCampLiberationPassPackItemDescription");

        itemDetails.amount = item.amount;
        itemDetails.icon = "prison-camp-release";

        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }


    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
